import { Injectable, EventEmitter, Output } from '@angular/core';
import {EndpointService} from "../../services/endpoint/endpoint.service";
import {UserService} from "../user.service";
import {HttpClient} from "@angular/common/http";
import {UserSession, HttpOptions} from "../../modele/authModel";
import {NGXLogger} from "ngx-logger";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RelationService {
    private log_prefix: string = "RelationService:";
    private local_http_opts: HttpOptions;

    constructor(
        private endpointSrv: EndpointService,
        private userService: UserService,
        private http:HttpClient,
        private logger: NGXLogger,
    ) {
        this.local_http_opts = this.userService.getCurrentHttpOptionsForBackend();
        this.userService.getUserSessionBasedHttpOptionsAsSubject().subscribe(httpOpts => {
            this.local_http_opts = httpOpts;
            this.logger.info(this.log_prefix,"user service: httpOptions received");
        });
     }

     sendNewRelationRequest(user_id) {
         return new Observable((observer)=>{
             this.endpointSrv.getCreateNewRelationRequests(user_id).subscribe((sendNewRelationRequest)=>{
                 observer.next(sendNewRelationRequest);
             });
         });
     }
     statusHasSendRelation(user_id) {
         return new Observable((observer)=>{
             this.endpointSrv.getCheckUserHaveSendRelationRequest(user_id).subscribe((statusHasSendRelation)=>{
                 observer.next(statusHasSendRelation);
             });
         });
     }
     statusRelation(user_id) {
         return new Observable((observer)=>{
             this.endpointSrv.getCheckRelationStatusRequest(user_id).subscribe((statusRelation)=>{
                 observer.next(statusRelation);
             });
         });
     }
     deleteRelationRequest(user_id) {
         return new Observable((observer)=>{
             this.endpointSrv.getDeleteRelationRequest(user_id).subscribe((deleteRelationRequest)=>{
                 observer.next(deleteRelationRequest);
             });
         });
     }
     dontAcceptRelationRequest(user_id) {
         return new Observable((observer)=>{
             this.endpointSrv.getDontAcceptRelationRequest(user_id).subscribe((dontAcceptRelationRequest)=>{
                 observer.next(dontAcceptRelationRequest);
             });
         });
     }


     getRelationUnreadCountRequest() {
         return new Observable((observer)=>{
             this.endpointSrv.getRelationUnreadCountRequest().subscribe((getRelationUnreadCountRequest)=>{
                 observer.next(getRelationUnreadCountRequest);
             });
         });
     }
     getRelationRequests(user_relation_status) {
         return new Observable((observer)=>{
             this.endpointSrv.getRelationRequests(user_relation_status).subscribe((getRelationRequests)=>{
                 observer.next(getRelationRequests);
             });
         });
     }
     getAcceptRelationRequest(user_id) {
         return new Observable((observer)=>{
             this.endpointSrv.getAcceptRelationRequest(user_id).subscribe((getAcceptRelationRequest)=>{
                 observer.next(getAcceptRelationRequest);
             });
         });
     }

     getCheckUserHaveSendRelationRequest(user_id) {
         return new Observable((observer)=>{
             this.endpointSrv.getCheckUserHaveSendRelationRequest(user_id).subscribe((getCheckUserHaveSendRelationRequest)=>{
                 observer.next(getCheckUserHaveSendRelationRequest);
             });
         });
     }

     getYouHaveSendRelationRequestRequest(user_id) {
         return new Observable((observer)=>{
             this.endpointSrv.getYouHaveSendRelationRequestRequest(user_id).subscribe((getYouHaveSendRelationRequestRequest)=>{
                 observer.next(getYouHaveSendRelationRequestRequest);
             });
         });
     }










}
